import { useTranslation } from "react-i18next";

/** Whether the search behind a field takes fuzzy words; `unknown` until the engine is known. */
export type FuzzySupport = "available" | "unavailable" | "unknown";

/**
 * What a search says of documents' keys: nothing (a search of library items); that a key finds
 * its document first (TR-B4-03); or also that a key may end in a version or a segment, where the
 * search opens what it finds (F135).
 */
export type KeyHelp = "none" | "findsDocument" | "opensAddress";

/** The rules of DMW's search syntax, folded away until asked for. */
export default function SearchSyntaxHelp({ fuzzy, keyHelp }: { fuzzy: FuzzySupport; keyHelp: KeyHelp }) {
  const { t } = useTranslation();
  return (
    <details className="app-help-text text-xs">
      <summary className="cursor-pointer">{t("search.syntax.title")}</summary>
      <ul className="mt-1 list-disc space-y-0.5 pl-5">
        {keyHelp === "none" ? null : <li>{t("search.syntax.key")}</li>}
        {keyHelp === "opensAddress" ? <li>{t("search.syntax.address")}</li> : null}
        <li>{t("search.syntax.words")}</li>
        <li>{t("search.syntax.phrase")}</li>
        <li>{t("search.syntax.or")}</li>
        <li>
          {t("search.syntax.fuzzy")}
          {fuzzy === "unavailable" ? <strong className="block">{t("search.syntax.fuzzyLightMode")}</strong> : null}
        </li>
      </ul>
    </details>
  );
}
